import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import { GOLD_GRADIENT } from "../components/ProductLogo";

/**
 * Scene 34 — Section 6 opener · ""One more thing.""
 * Pure homage to the iconic Steve Jobs reveal moment. Slow, slick reveal,
 * no eyebrow, quote marks frame the line. Single-stage.
 */

export default function Scene34_ProposalFrame() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-proposal-frame">
      {/* Slow, intense ambient gold pulse */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at center, rgba(233,168,32,0.26) 0%, transparent 70%)",
            "radial-gradient(ellipse at center, rgba(233,168,32,0.42) 0%, transparent 70%)",
            "radial-gradient(ellipse at center, rgba(233,168,32,0.26) 0%, transparent 70%)",
          ],
        }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full text-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center"
          data-testid="one-more-thing-reveal"
        >
          <motion.h2
            initial={{ opacity: 0, scale: 0.78, filter: "blur(40px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 2.6, ease: [0.16, 1, 0.3, 1] }}
            className="kn-display leading-[0.95]"
            style={{
              fontSize: "clamp(80px, 13vw, 220px)",
              color: "#e2e8f0",
              fontWeight: 900,
              letterSpacing: "-0.04em",
              textShadow: "0 0 80px rgba(233,168,32,0.35)",
            }}
            data-testid="one-more-thing-headline"
          >
            <span
              style={{
                background: GOLD_GRADIENT,
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
                fontWeight: 400,
                marginRight: "0.05em",
              }}
            >
              &ldquo;
            </span>
            One more{" "}
            <span
              style={{
                background:
                  "linear-gradient(135deg, #d4940a 0%, #e9a820 50%, #d4940a 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
                textShadow: "0 0 80px rgba(233,168,32,0.45)",
              }}
            >
              thing.
            </span>
            <span
              style={{
                background: GOLD_GRADIENT,
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
                fontWeight: 400,
                marginLeft: "0.02em",
              }}
            >
              &rdquo;
            </span>
          </motion.h2>

          {/* Steve Jobs attribution */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 2.2 }}
            className="mt-12 inline-flex items-center gap-3"
            data-testid="steve-jobs-attribution"
          >
            <span
              className="block w-12 h-px"
              style={{ background: "rgba(255,255,255,0.40)" }}
            />
            <span
              className="text-sm sm:text-base tracking-[0.32em] uppercase italic"
              style={{ color: "rgba(255,255,255,0.65)" }}
            >
              Steve Jobs
            </span>
            <span
              className="block w-12 h-px"
              style={{ background: "rgba(255,255,255,0.40)" }}
            />
          </motion.div>
        </motion.div>
      </div>
    </SceneShell>
  );
}
